import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Download } from 'lucide-react';

function ImageCarouselModal({ images, deliveryId, recipientName, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);

 

  function handlePrevious() {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  }

  function handleNext() {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }

  function handleKeyDown(e) {
    if (e.key === 'ArrowLeft') handlePrevious();
    if (e.key === 'ArrowRight') handleNext();
    if (e.key === 'Escape') onClose();
  }

  function handleDownload() {
    const link = document.createElement('a');
    link.href = images[currentIndex];
    link.download = `delivery_${deliveryId}_image_${currentIndex + 1}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);

   if (!images || images.length === 0) {
    return null;
  }

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/90 z-50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div 
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <div 
          className="relative w-full max-w-5xl"
          onClick={e => e.stopPropagation()}
        >
          {/* Header */}
          <div className="absolute top-0 left-0 right-0 z-10 flex items-center justify-between p-4 bg-gradient-to-b from-black/60 to-transparent">
            <div className="text-white font-montserrat">
              <h3 className="text-lg font-bold">
                Entrega #{deliveryId}
              </h3>
              <p className="text-sm text-white/80">
                {recipientName}
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-2 bg-white/10 hover:bg-white/20 rounded-full transition-colors text-white"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Image Container */}
          <div className="relative bg-black rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={images[currentIndex]}
              alt={`Imagen ${currentIndex + 1} de ${images.length}`}
              className="w-full h-[70vh] object-contain"
            />

            {/* Navigation Arrows */}
            {images.length > 1 && (
              <>
                <button
                  onClick={handlePrevious}
                  className="absolute left-4 top-1/2 -translate-y-1/2 p-3 bg-black/50 hover:bg-black/70 rounded-full transition-colors text-white"
                >
                  <ChevronLeft className="w-6 h-6" />
                </button>
                <button
                  onClick={handleNext}
                  className="absolute right-4 top-1/2 -translate-y-1/2 p-3 bg-black/50 hover:bg-black/70 rounded-full transition-colors text-white"
                >
                  <ChevronRight className="w-6 h-6" />
                </button>
              </>
            )}
          </div>

          {/* Footer */}
          <div className="absolute bottom-0 left-0 right-0 z-10 flex items-center justify-between p-4 bg-gradient-to-t from-black/60 to-transparent">
            {/* Image Counter */}
            <div className="flex items-center gap-2">
              <div className="px-3 py-1.5 bg-black/50 backdrop-blur-sm rounded-full text-white text-sm font-montserrat font-semibold">
                {currentIndex + 1} / {images.length}
              </div>
            </div>

            {/* Download Button */}
            <button
              onClick={handleDownload}
              className="flex items-center gap-2 px-4 py-2 bg-brand-gold hover:bg-brand-gold/90 rounded-lg transition-colors text-white font-montserrat font-semibold shadow-lg"
            >
              <Download className="w-4 h-4" />
              Descargar
            </button>
          </div>

          {/* Thumbnails */}
          {images.length > 1 && (
            <div className="mt-4 flex items-center justify-center gap-2 flex-wrap max-w-full overflow-x-auto px-4">
              {images.map((img, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`relative flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
                    index === currentIndex
                      ? 'border-brand-gold scale-110 shadow-lg'
                      : 'border-white/30 hover:border-white/60 opacity-70 hover:opacity-100'
                  }`}
                >
                  <img
                    src={img}
                    alt={`Miniatura ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                  {index === currentIndex && (
                    <div className="absolute inset-0 bg-brand-gold/20" />
                  )}
                </button>
              ))}
            </div>
          )}

          {/* Keyboard Hints */}
          {images.length > 1 && (
            <div className="mt-4 text-center">
              <p className="text-sm text-white/60 font-montserrat">
                Usa ← → para navegar • ESC para cerrar
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ImageCarouselModal;